<template>
    <div class="main">
        <!-- 登录弹窗 -->
        <div class="login-box" v-show="loginShow">
            <LoginWindow :setUserInfo='setUserInfo'></LoginWindow>
        </div>
        <!-- 定价弹窗 -->
        <!-- <Pricing v-show="pricingShow" :offPricingButton="offPricingButton"></Pricing> -->
        <ExchangeDrawer v-if="isExchangeDrawer" :offExchange="offExchange"></ExchangeDrawer>
        <!-- 遮罩层 -->
        <div class="allShade" v-show="allShade" @click="allShadeClick"></div>
        <!-- 头部-->
        <div class="header-auto">
            <img src="@/assets/kokoni-logo-白色-04 1.png" class="heightLeftImg">
            <div class="header-right">
                <div class="lang-style" @click="selectLangClick">
                    <div class="lang-fonts">{{ $t('home.headerLanguage') }}</div>
                    <img src="@/assets/arrow-up.png" v-if="selectLangShow">
                    <img src="@/assets/arrow-down.png" :style="{ marginTop: '0.03rem' }" v-else>
                </div>
                <!-- 下拉框 -->
                <ul class="drop-down-box" v-show="selectLangShow">
                    <li class="drop-down-li" v-for="item in liList" :key="item.id"
                        @click="submitLang(item.name, item.id, item.lang)">
                        <div class="li-name" :class="{ 'active': selectLangId == item.id }">{{ item.name }}</div>
                        <img class="drop-down-img" src="@/assets/Slice.png"
                            v-show="selectLangId == item.id ? false : true">
                        <img class="drop-down-img" src="@/assets/checked.png"
                            v-show="selectLangId == item.id ? true : false">
                    </li>
                </ul>
                <button class="login" @click="opppenLoginButton" v-if="isLoginIn == 1 ? true : false">{{
            $t('home.headerLogin') }}</button>
                <img @click="AccountPage" :src="UserImg" v-if="isLoginIn == 2 ? true : false" class="isloginImg">
                <img @click="AccountPage" src="@/assets/29x29.png" v-if="isLoginIn == 3 ? true : false"
                    class="isloginImg">
                <div @click="AccountPage" class="real_name_style">{{ real_name }}</div>
            </div>
        </div>
        <!-- 顶部 -->
        <div class="video-container">
            <video class="background-video" src="@/assets/bg.mp4" autoplay loop muted></video>
            <div class="content">
                <div class="fonts-style-content">
                    <div class="fonts-topFonts">{{ $t('content.typeface1') }}</div>
                    <!-- <div class="fonts-topFonts">{{ $t('content.typeface2') }}</div> -->
                    <div class="inner-txt">
                        <div>{{ $t('content.fontsname') }}</div>
                        <div>Enhance your 3D workflow and unlock your creativity with KOKONI’s 3D</div>
                    </div>
                </div>
                <div class="btn-wrap">
                    <div class="content-buttonLeft" @click="loginOrThree">{{ $t('content.buttonLeft') }}</div>
                    <!-- <div class="content-buttonRight" @click="isExchangeDrawer = true">
                        {{ $t('content.buttonRight') }}
                        <img src="@/assets/icon／arrow-right.png">
                    </div> -->
                </div>
                <div class="content-buttonButtom">
                    <div class="content-download-box" @click="downloadButton">
                        <img class="downdload-icon-style" src="@/assets/icon／downdload.png">
                        <span>{{ $t('content.buttonButtom') }}</span>
                        <!-- 下载弹窗 -->
                        <div class="downloadShade" v-show="downloadShade" @click.stop="downloadShadeClick"></div>
                        <div class="download-popover" v-show="downloadShow">
                            <button @click="downloadBut('ios')" class="download-popover-style"
                                v-on:mouseover="downloadMouseover('ios')" v-on:mouseout="downloadMouseout('ios')">
                                <img src="@/assets/normalios.png" v-show="downloadIos == true ? true : false">
                                <img src="@/assets/hoverios.png" v-show="downloadIos == true ? false : true">
                                iOS Download
                            </button>
                            <button @click="downloadBut('android')" class="download-popover-style"
                                :style="{ marginTop: '0.3rem' }" v-on:mouseover="downloadMouseover('android')"
                                v-on:mouseout="downloadMouseout('android')">
                                <img src="@/assets/normalandroid.png" v-show="downloadAndroid == true ? true : false">
                                <img src="@/assets/hoverandroid.png" v-show="downloadAndroid == true ? false : true">
                                Android Download
                            </button>
                            <button @click="downloadBut('windows')" class="download-popover-style"
                                :style="{ marginTop: '0.3rem' }" v-on:mouseover="downloadMouseover('windows')"
                                v-on:mouseout="downloadMouseout('windows')">
                                <img src="@/assets/normalwindows.png" v-show="downloadWindows == true ? true : false">
                                <img src="@/assets/hoverwindows.png" v-show="downloadWindows == true ? false : true">
                                Windows Download
                            </button>
                            <button @click="downloadBut('mac')" class="download-popover-style"
                                :style="{ marginTop: '0.3rem' }" v-on:mouseover="downloadMouseover('mac')"
                                v-on:mouseout="downloadMouseout('mac')">
                                <img src="@/assets/normalios.png" v-show="downloadMac == true ? true : false">
                                <img src="@/assets/hoverios.png" v-show="downloadMac == true ? false : true">
                                MacOS Download
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 轮播图 -->
        <div class="video-style-box">
            <!-- <div class="video-style">
                <img src="@/assets/Group 1000006115.png" class="video-style-img">
            </div> -->
            <div class="swiper-fonts">Model Gallery</div>
            <div class="swiper-min-box">
                <swiper :style="{ padding: '0.4rem' }" @progress="onProgress" v-bind="swiperOptions" :modules="modules"
                    @setTransition="onSetTransition" @slideChange="slideChangeFun">
                    <swiper-slide style='width:3.6rem' v-for="item in banberList" :key="item.group_id"> 
                        <div class="swiper-item">
                            <img :src="item.default_image" class="swiper-item-img">
                            <div class="swiper-item-fonts">{{item.group_name}}</div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
        <!-- 图片展示  -->
        <div class="img-matrix-box">
            <div class="img-matrix-fonts">Creative display</div>
            <div class="img-matrix-item-box">
                <div class="img-matrix-itembox" v-for="n in 3" :key="n">
                    <div class="img-martix-item" v-for="k in 4" :key="k" @click="loginOrThree($event, gifModelList[((k-1)+(n-1)*4)])">
                        <img :class="{'img-martix-item-img':true,'zoomClass':is_mouseent_eid == ((k-1)+(n-1)*4)?true:false}" :src="`${publicPath}output/${gifModelList[((k-1)+(n-1)*4)]}/model.gif`" @mouseenter="displayMouseenter(((k-1)+(n-1)*4))" @mouseleave="displayMouseleave()">
                    </div>
                </div>
            </div>
        </div>
        <div class="card-box-class">
            <div class="card-box-fonts">Game-Changing 3D Generative Foundation Models</div>
            <div class="card-item-box">
                <div class="card-item">
                    <img src="@/assets/Group 1000006169.png" class="card-item-img">
                    <div class="card-item-fonts">From Image to 3D: Transform 2D images into 3D objects with KOKONI 3D foundation model, effortlessly converting flat visuals into dynamic, three-dimensional models ready for 3D printing and more</div>
                    <div class="card-item-button" @click="loginOrThree">
                        Try Now
                        <img src="@/assets/icon／arrow-right.png">
                    </div>
                </div>
                <div class="card-item" style="margin-left: 0.2rem">
                    <img src="@/assets/Group 1000006170.png" class="card-item-img">
                    <div class="card-item-fonts">From Text to 3D: Effortlessly produce 3D models in mere seconds by inputting text prompts. KOKONI’s foundation model transforms your written descriptions into high-quality 3D designs model and available for instant 3D Prints and more</div>
                    <div class="card-item-button" style="margin-top: 0.2rem" @click="loginOrThree">
                        Try Now
                        <img src="@/assets/icon／arrow-right.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="footer-title">{{ $t('footerTitle.titlename') }}</div>
            <div class="footer-input-box">
                <div class="footer-input">
                    <input class="input" :spellcheck="false" v-model="emaliInput" type="text"
                        placeholder="Enter Your Email Here">
                    <button>SUBSCRIBE</button>
                </div>
            </div>
            <div class="middle-box">
                <div class="middle-style">
                    <!-- <div class="middle-left"> -->
                    <img class="left-middle-style" src="@/assets/kokoni-logo组合-04 1.png">
                    <!-- </div> -->
                    <!-- <div >图片</div> -->
                    <!-- <img src="@/assets/image 2081.png" class="middle-right"> -->
                </div>
                <!-- <div class="middle-line"></div>
                <div class="footer-buttom">
                    <div class="buttom-left">Copyright © SUDOAI | All Rights Reserved</div>
                    <div class="buttom-right">
                        <img class="buttom-right-item" src="@/assets/communicationDiscord.png">
                        <img class="buttom-right-item" src="@/assets/communicationins.png">
                        <img class="buttom-right-item" src="@/assets/communicationmail.png">
                        <img class="buttom-right-item" src="@/assets/communicationtwitter.png">
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onBeforeCreat } from 'vue'
import { useI18n } from 'vue-i18n'
import { Right, Download } from '@element-plus/icons-vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import LoginWindow from '@/components/Loginwindow.vue'
import { Autoplay, Pagination, Navigation, Scrollbar } from 'swiper'
import 'swiper/css';
import { loginToken } from '@/api/modules/login'
import { useRouter } from 'vue-router'
import Pricing from '@/components/pricing.vue'
import ExchangeDrawer from '@/components/exchangeDrawer.vue'
import { getPhotoExampleList ,getModelsGroupByBar} from '@/api/modules/model'
export default {
    components: {
        Swiper,
        SwiperSlide,
        Right,
        Download,
        Pricing,
        LoginWindow,
        ExchangeDrawer
    },
    setup() {
        const router = useRouter()
        const { locale: i18nLanguage } = useI18n() //核心思想就是改变 useI18n 解构出来的locale
        const modules = [Autoplay, Pagination, Navigation, Scrollbar]
        const selectLangShow = ref(false) // 多语言选择下拉框弹窗开关  true，弹出 false，关闭
        const selectLangId = ref(1) // 1表示英文
        const isLoginIn = ref(1) // 是否登录，1 未登录，2 已登录有头像，3已登录没头像
        const emaliInput = ref('')
        const loginShow = ref(false) // 登录弹窗
        const allShade = ref(false) // 整体遮罩层
        const downloadShade = ref(false) // 下载弹窗遮罩层
        const downloadShow = ref(false)// 下载弹窗
        const downloadIos = ref(true) // ios 下载 点击切换
        const downloadAndroid = ref(true) // ios 图标地址 点击切换
        const downloadWindows = ref(true) // Windows 下载 点击切换
        const downloadMac = ref(true) // Mac 下载 点击切换
        // const pricingShow = ref(false)//定价弹窗
        const isExchangeDrawer = ref(false) // 兑换弹窗
        const ErrorLogin = ref(false)// 登录弹窗 账号密码错误
        const UserImg = ref('') // 登录成功显示的用户头像
        const real_name = ref('') // 登录成功显示的用户昵称
        const banberList = ref([])// 轮播图列表
        const is_mouseent_eid = ref(-1)
        const gifModelList = ref([
            "239500-", "239530-", "239557-", "239617-", "239650-", "239683-",
            "239747-", "239758-", "240622-", "240853-", "240883-", "240913-"
        ])//Creative display的模型列表
        const publicPath = ref(process.env.BASE_URL)
        // 下拉框多语言列表
        const liList = ref([
            // {
            //     name: '简体中文',
            //     lang: 'zh-cn',
            //     id: 0
            // },
            {
                name: 'English',
                lang: 'en-us',
                id: 1
            },
        ])
        function displayMouseleave(){
            is_mouseent_eid.value = -1
        }
        function displayMouseenter(eid){
            is_mouseent_eid.value = eid  
        }
        // Swiper配置选项
        const swiperOptions = {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,// 允许在用户交互后继续自动播放
            },
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            loopedSlides: 2,
            initialSlide:3,
            watchSlidesProgress: true,
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },
            // pagination: {
            //     el: '.swiper-pagination',
            //     //clickable :true,
            // },
            on: {
                progress: function (progress) {

                },
                setTransition: function (transition) {


                }
            }
        };

        function onSetTransition(swiper, transition) {
            // console.log(swiper, transition, "s")
            let slides = swiper.slides;
            // let slides = document.querySelectorAll(".swiper-slide");
            for (let i = 0; i < slides.length; i++) {
                let slide = slides[i]
                slide.style.transition = transition;
            }
        }
        function onProgress(swiper) {
            let slides = document.querySelectorAll(".swiper-slide");
            let slideWidth = slides[0]?.clientWidth;
            let offsetX = 0;
            if (slides?.[1]) {
                offsetX = slideWidth - (slideWidth * (1 - Math.abs(slides[1].progress) / 5));
            }
            // let slides = swiper.slides;
            // console.log(Array.from(slides).map(item => item.progress))
            // console.log(swiper, slides, this,slideWidth)
            for (let i = 0; i < slides.length; i++) {
                let slide = slides[i];
                let slideProgress = slides[i].progress;

                let modify = 1;
                if (Math.abs(slideProgress) > 1) {
                    modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                }
                let scale = 1 - Math.abs(slideProgress) / 6;
                let translate = slideWidth - (slideWidth * scale) - 20;
                let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                // slide.style.transform = 'translateX(' + translate + 'px) scale(' + scale + ')';
                // slide.style.transform = 'translateX('+translate+') scale(' + scale + ')';
                slide.style.transform = ' scale(' + scale + ')';
                slide.style.zIndex = zIndex;
                slide.style.opacity = 1;
                if (Math.abs(slideProgress) > 3) {
                    slide.style.opacity = 0;
                }
            }
        }
        function slideChangeFun(val) {
            // console.log('改变了，activeIndex为', val.activeIndex);
        }
        // 函数用于将px转换为rem
        function getRemValue(pxValue) {
            var htmlFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
            return pxValue * (1 / htmlFontSize);
        }
        onMounted(() => {
            localStorage.setItem('2d3d-language', 'en-us')
            let token = localStorage.getItem('token')
            let user_data = JSON.parse(localStorage.getItem('data'))
            if (token && user_data) {
                setUserInfo(user_data, 2)
            }else if(token && !user_data){
                setUserInfo('', 1)
            }
        })
        // 轮播图
        getBanberList()
        async function getBanberList(){
            let res = await getModelsGroupByBar()
            // console.log("轮播图",res)
            if(res.code == 200){
                banberList.value = res.data.items
            }
        }
        function offExchange() {
            isExchangeDrawer.value = false
        }
        function downloadBut(type) {
            if (type == 'android') {
                let link = document.createElement("a");
                link.style.display = "none";
                document.body.appendChild(link);
                link.href = 'https://www.kokoni.ltd/apk/KOKONI3D.apk';

                link.click();
            } else if (type == 'ios') {
                let link = document.createElement("a");
                link.style.display = "none";
                document.body.appendChild(link);
                link.href = 'https://apps.apple.com/cn/app/id1601362689'
                link.click();
            } else if (type == 'windows') {
                let link = document.createElement("a");
                link.style.display = "none";
                document.body.appendChild(link);
                link.href = 'https://www.kokoni.ltd/upgrade/soft/KOKONI3D_Windows.exe'
                link.click();
            } else if (type == 'mac') {
                let link = document.createElement("a");
                link.style.display = "none";
                document.body.appendChild(link);
                link.href = 'https://www.kokoni.ltd/upgrade/soft/KOKONI3D_Mac.dmg'
                link.click();
            }
        }
        // 关闭按年按月弹窗
        // function offPricingButton() {
        //     pricingShow.value = false
        // }
        // 切换多语言
        function submitLang(name, id, lang) {
            localStorage.setItem('2d3d-language', lang)
            selectLangId.value = id
            i18nLanguage.value = lang  // 切换语言
            selectLangShow.value = false
        }
        // 判断是否登录，没有登录登录，登录跳转
        function loginOrThree(e, gifFloder) {
            if (isLoginIn.value == 1) {
                opppenLoginButton()
            } else {
                if(gifFloder){
                    router.push(`/three/${gifFloder}`)
                }else{
                    router.push("/three")
                }
            }
        }
        // 登录成功 | 默认登录 | 设置用户头像用户名
        async function setUserInfo(res, type) {
            let data;
            if (type == 1) { // 微信或苹果登录
                data = await loginToken()
                localStorage.setItem("data",JSON.stringify(data))
                if (data.code == 200) {
                    if (data.data.portrait) { // 赋值头像
                        isLoginIn.value = 2
                        UserImg.value = data.data.portrait
                        real_name.value = data.data.real_name
                        localStorage.setItem('real_name', data.data.real_name)
                    } else {
                        isLoginIn.value = 3
                        real_name.value = data.data.real_name
                        localStorage.setItem('real_name', data.data.real_name)
                    }
                    // router.push('/three')
                } else {
                    isLoginIn.value = 1
                    UserImg.value = ''
                    real_name.value = ''
                }
                allShadeClick()// 关闭弹窗
            } else {
                data = res
                localStorage.setItem('token', data.data.token)
                localStorage.setItem('real_name', data.data.real_name)
                localStorage.setItem("data",JSON.stringify(data))
                if (data.data.portrait) {
                    isLoginIn.value = 2
                    UserImg.value = data.data.portrait
                    real_name.value = data.data.real_name
                } else {
                    isLoginIn.value = 3
                    real_name.value = data.data.real_name
                }
                // router.push('/three')
                allShadeClick()// 关闭弹窗
            }
        }
        /**
         * 多语言下拉框
         */
        function selectLangClick() {
            selectLangShow.value = !selectLangShow.value
        }
        /**
         * 登录弹窗 打开弹窗
         */
        function opppenLoginButton() {
            if (selectLangShow.value == true) {
                selectLangShow.value = false // 优先关闭多语言弹窗
            } else {
                allShade.value = true // 整体遮罩层
                loginShow.value = true // 登录弹窗
            }
        }
        /**
         * 整体遮罩层
         */
        function allShadeClick() {
            allShade.value = false //整体遮罩层
            loginShow.value = false // 登录弹窗
            downloadShow.value = false // 下载弹窗
            // pricingShow.value = false // 定价弹窗
        }

        function downloadShadeClick() {
            downloadShade.value = false //整体遮罩层
            downloadShow.value = false // 下载弹窗
        }
        /**
         * 下载弹窗
         */
        function downloadButton() {
            downloadShade.value = true //整体遮罩层
            downloadShow.value = true
        }
        /**
         * 下载安装 鼠标划入划出
         */
        function downloadMouseover(type) {
            if (type == 'ios') {
                downloadIos.value = false
            } else if (type == 'android') {
                downloadAndroid.value = false
            } else if (type == 'windows') {
                downloadWindows.value = false
            } else if (type == 'mac') {
                downloadMac.value = false
            }
        }
        function downloadMouseout(type) {
            if (type == 'ios') {
                downloadIos.value = true
            } else if (type == 'android') {
                downloadAndroid.value = true
            } else if (type == 'windows') {
                downloadWindows.value = true
            } else if (type == 'mac') {
                downloadMac.value = true
            }
        }

        /**
         * 登录弹窗验证账号密码提示
         */
        function inputFocus() {
            ErrorLogin.value = false // 输入框获得焦点退出错误提示
        }
        /**
         * 跳转账户页面
         */
        function AccountPage() {
            router.push('/three')
        }
        return {
            selectLangClick,
            selectLangShow,
            submitLang,
            loginOrThree,
            modules,
            Right,
            emaliInput,
            selectLangId,
            liList,
            loginShow,
            opppenLoginButton,
            allShade,
            allShadeClick,
            downloadShade,
            downloadShadeClick,
            downloadShow,
            downloadButton,
            downloadMouseover,
            downloadMouseout,
            // pricingShow,
            downloadIos,
            downloadAndroid,
            downloadWindows,
            downloadMac,
            ErrorLogin,
            inputFocus,
            isLoginIn,
            UserImg,
            real_name,
            AccountPage,
            setUserInfo,
            // offPricingButton,
            downloadBut,
            isExchangeDrawer,
            offExchange,
            swiperOptions,
            slideChangeFun,
            onSetTransition,
            onProgress,
            banberList,
            displayMouseenter,
            displayMouseleave,
            is_mouseent_eid,
            gifModelList,
            publicPath
        }
    }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: BoldFonts;
    src: url('@/fonts/PingFang-SC-Bold.ttf');
}

@font-face {
    font-family: SemiboldFonts;
    src: url('@/fonts/PingFang-SC-Semibold.ttf');
}

@font-face {
    font-family: RegularFonts;
    src: url('@/fonts/PingFang-SC-Regular.ttf');
}



.main {
    position: relative;
    width: 100%;
    background-color: #ffffff;
    overflow: hidden;

    & * {
        box-sizing: border-box;
    }

    // 登录弹窗
    .login-box {
        width: 5.05rem;
        height: 6.51rem;
        background: #ebeaea;
        box-shadow: 0px 0.1rem 0.4rem -0.04rem rgba(0, 0, 0, 0.02);
        border-radius: 0.2rem;
        opacity: 1;
        position: fixed;
        left: 0;
        right: 0;
        margin: 1rem auto;
        z-index: 30;
        padding: 0.48rem 0.3rem 0.47rem 0.3rem;
        box-sizing: border-box;

        .loginTitle {
            display: flex;
            justify-content: center;

            .loginTitle-left {
                font-size: 0.3rem;
                font-family: Roboto, Roboto;
                font-weight: bold;
                color: #0E140F;
                margin-right: 0.1rem;
            }

            img {
                width: 1.1rem;
                height: 0.48rem;
                margin-top: -0.06rem;
            }
        }

        .loginTitle-fonts {
            font-size: 0.16rem;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #AEB4AF;
            text-align: center;
        }

        .errorFonts {
            margin-top: 0.05rem;
            position: absolute;
            color: rgb(237, 28, 36);
            font-size: 0.16rem;
            font-family: interbureau, interbureau;
            font-weight: normal;
        }

        .loginInputName {
            margin-top: 0.32rem;

            .input-fonts {
                font-size: 0.12rem;
                font-family: interbureau, interbureau;
                font-weight: normal;
                color: #0E140F;
            }

            .login-input {
                width: 100%;
                height: 0.56rem;
                border-radius: 0.6rem;
                opacity: 1;
                // border: 1px solid #cf0606;
                border: 0.01rem solid #0667CF;
                font-size: 0.16rem;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #999999;
                line-height: 0.26rem;
                margin-top: 0.02rem;
                padding: 0 0 0 0.2rem;
                box-sizing: border-box;
                display: block;
            }

            .login-input:focus {
                outline: none;
            }

            .error-login-input {
                border: 0.01rem solid #cf0606 !important;
            }
        }

        // 忘记密码
        .ForgotPassword {
            text-align: right;
            font-size: 0.14rem;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #0667CF;
            margin-top: 0.16rem;

            a {
                text-decoration: none;
            }
        }

        .login-button {
            width: 100%;
            height: 0.56rem;
            background: #0667CF;
            border-radius: 0.6rem;
            opacity: 0.7;
            font-size: 0.16rem;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #FFFFFF;
            border: #0667CF;
            margin-top: 0.3rem;
            cursor: pointer;
            display: block;
        }

        .SignUp {
            font-size: 0.14rem;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #333333;
            margin-top: 0.2rem;

            a {
                text-decoration: none;
                margin-left: 0.1rem;
            }
        }

        .google-button {
            width: 100%;
            height: 0.56rem;
            border-radius: 60rem;
            opacity: 1;
            border: 0.01rem solid #0667CF;
            background: #fff;
            font-size: 0.16rem;
            font-family: interbureau, interbureau;
            font-weight: normal;
            color: #0E140F;
            margin-top: 0.62rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                width: 0.16rem;
                height: 0.16rem;
                margin-right: 0.01rem;
            }
        }

    }

    .allShade {
        width: 100%;
        height: 100%;
        // background: rgba(0,0,0,0.15);
        position: absolute;
        top: 0;
        z-index: 25;
        background: rgba(0, 0, 0, 0.6);
        // background: #f00;
        filter: alpha(opacity=60);
        /*设置透明度为60%*/
        opacity: 1;
        /*非IE浏览器下设置透明度为60%*/
        // display: none;
    }

    // 头部
    .header-auto {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 20;
        height: 0.88rem;
        background: #4B48FF;
        color: #fff;
        display: flex;
        justify-content: space-between;
        padding: 0 3.95rem 0 3.49rem;
        align-items: center;

        //左边logo图片
        .heightLeftImg {
            width: 1.64rem;
            height: 0.5rem;
        }


        .header-right {
            display: flex;
            align-items: center;
            position: relative;

            // 右边 多语言
            .lang-style {
                display: flex;
                align-items: center;
                cursor: pointer;
                font-size: 0.16rem;

                .lang-fonts {
                    font-family: SemiboldFonts;
                    font-weight: 600;
                    font-size: 0.16rem;
                    color: #FFFFFF;
                    text-align: center;
                }

                img {
                    width: 0.3rem;
                    height: 0.3rem;
                }
            }

            //下拉框
            .drop-down-box {
                width: 3.36rem;
                // height: 5.36rem;
                height: auto;
                background: #ffffff;
                box-shadow: 0px 0.1rem 0.4rem -0.04rem rgba(0, 0, 0, 0.02);
                border-radius: 0.2rem;
                opacity: 1;
                position: absolute;
                top: 0.78rem;
                right: 1.51rem;
                z-index: 1000;
                list-style: none;
                padding: 0.2rem;
                box-sizing: border-box;
                cursor: pointer;

                .drop-down-li {
                    display: flex;
                    justify-content: space-between;
                    width: 2.96rem;
                    height: 0.26rem;

                    .li-name {
                        width: 2.96rem;
                        height: 0.26rem;
                        font-size: 0.18rem;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 600;
                        color: #999999;


                    }

                    .drop-down-img {
                        width: 0.24rem;
                        height: 0.24rem;
                        display: block;
                    }

                    // 多语言选中，改变字体颜色
                    .active {
                        color: #0667CF;
                    }
                }

                .drop-down-li+.drop-down-li {
                    margin-top: 0.41rem;
                }
            }



            .login {
                width: 1.54rem;
                height: 0.48rem;
                border-radius: 0.37rem;
                opacity: 1;
                border: 0.02rem solid #FFFFFF;
                background: none;
                font-size: 0.16rem;
                font-family: SemiboldFonts;
                font-weight: 600;
                color: #FFFFFF;
                margin-left: 0.62rem;
                cursor: pointer;
            }

            .isloginImg {
                width: 0.4rem;
                height: 0.4rem;
                margin-left: 0.62rem;
                border-radius: 0.2rem;
                cursor: pointer;
            }

            .real_name_style {
                font-size: 0.16rem;
                margin-left: 0.1rem;
                cursor: pointer;
            }

            .outLogin {
                margin-left: 0.1rem;
                cursor: pointer;
                font-size: 0.16rem;
            }
        }
    }

    
    .video-container{
        position: relative;
        height: 8.17rem;
        .background-video{
            position: absolute;
            right:0;
            height: 8.17rem;
            object-fit: cover;
        }
    }
    .content {
        position: relative;
        z-index:10;
        height: 8.17rem;
        border-radius: 0rem;
        // border: 1px solid;
        padding-top: 1.61rem;

        .fonts-style-content {
            text-align: center;
            cursor: default;
            .fonts-topFonts {
                width: 8rem;
                font-size: 0.6rem;
                font-family: BoldFonts;
                font-weight: bold;
                color: #536376;
                line-height: 0.72rem;
                text-shadow: 0.08rem 0.12rem 0.24rem rgba(0, 0, 0, 0.05);
                text-align: left;
                margin: 0.73rem 0 0 3.56rem;
            }

            .inner-txt {
                text-align: left;
                font-family: BoldFonts;
                font-size: 0.18rem;
                font-weight: normal;
                color: #8B92A0;
                line-height: 0.27rem;
                margin: 0.1rem 0 0 3.56rem;
            }
        }



        .btn-wrap {
            width: 5.2rem;
            display: flex;
            // justify-content: center;
            margin: 0.44rem 0 0 3.56rem;
            position: relative;


            .content-buttonLeft {
                width: 2.5rem;
                height: 0.6rem;
                background: #4B48FF;
                border-radius: 0.3rem;
                opacity: 1;
                font-size: 0.2rem;
                font-family: SemiboldFonts;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 0.6rem;
                text-align: center;
                cursor: pointer;
            }

            .content-buttonRight {
                width: 2.5rem;
                height: 0.6rem;
                background: #F4F5F6;
                border-radius: 0.3rem;
                opacity: 1;
                font-size: 0.2rem;
                font-family: SemiboldFonts;
                font-weight: 600;
                color: #536376;
                margin-left: 0.2rem;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 0.3rem;
                    height: 0.3rem;
                    margin-left: 0.1rem;
                }

            }
        }

        .content-buttonButtom {
            width: 2.5rem;
            margin: 0.38rem 0 0 3.56rem;
            display: flex;
            justify-content: left;

            .content-download-box {
                width: 2rem;
                display: flex;
                justify-content: left;
                align-items: center;
                position: relative;
                cursor: pointer;

                .downdload-icon-style {
                    width: 0.3rem;
                    height: 0.3rem;
                    margin-right: 0.04rem;
                }

                &>span {
                    font-size: 0.2rem;
                    font-family: SemiboldFonts;
                    font-weight: 600;
                    color: #4B48FF;
                }


                .content-buttonButtom-icon {
                    width: 26px;
                    height: 26px;
                    border-radius: 50%;
                    background-color: #0667CF;
                    margin-right: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .el-icon {
                        color: #fff;
                    }
                }

                .downloadShade{
                    position: fixed;
                    left:0;
                    right:0;
                    top:0;
                    bottom: 0;
                    z-index: 21;
                    background: rgba(0, 0, 0, 0.6);
                    filter: alpha(opacity=60);
                }

                // 下载弹窗
                .download-popover {
                    width: 3.34rem;
                    height: 3.8rem;
                    background: #ffffff;
                    box-shadow: 0px 0.1rem 0.4rem -0.04rem rgba(0, 0, 0, 0.02);
                    border-radius: 0.2rem;
                    opacity: 1;
                    position: absolute;
                    top: -1.05rem;
                    right: -3.42rem;
                    padding: 0.36rem;
                    box-sizing: border-box;
                    z-index: 25;
                    cursor: default;

                    .download-popover-style {
                        width: 100%;
                        height: 0.54rem;
                        border-radius: 0.6rem;
                        opacity: 1;
                        border: 0.02rem solid #333333;
                        background: #fff;
                        font-size: 0.18rem;
                        font-family: SemiboldFonts;
                        font-weight: 600;
                        color: #333333;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0.23rem;

                        img {
                            width: 0.3rem;
                            height: 0.3rem;
                            margin-top: -0.03rem;
                        }
                    }

                    .download-popover-style:hover {
                        background: #0667CF;
                        color: #fff;
                        border: #0667CF;
                    }
                }
            }

        }
    }

    .video-style-box {
        position: relative;
        // display: flex;
        // justify-content: center;
        // background: #f00;
        // margin-top: -2.32rem;
        padding: 0 4rem;
        box-sizing: border-box;

        .swiper-fonts {
            font-family: BoldFonts;
            font-weight: bold;
            font-size: 0.56rem;
            color: #536376;
            text-shadow: 8px 0.12rem 0.24rem rgba(0, 0, 0, 0.05);
            text-align: center;
            margin-top: 1.6rem;
            cursor: default;
        }

        .swiper-min-box {
            width: 100%;
            margin-top: 0.5rem;

            .swiper-item {
                width: 3.6rem;
                height: 3.8rem;
                // background: #f00;
                padding: 0.18rem 0.18rem 0rem 0.18rem;
                position: relative;
                background: #FFFFFF;
                box-shadow: 0 0.14rem 0.24rem 0 rgba(196,205,222,0.7);
                border-radius: 0.26rem;
                cursor: grab;
                .swiper-item-img {
                    width: 3.24rem;
                    height: 2.85rem;
                    display: block;
                    border-radius: 0.26rem;
                }

                .swiper-item-fonts {
                    width: 2.24rem;
                    font-family: BoldFonts;
                    font-weight: 500;
                    font-size: 0.2rem;
                    color: #536376;
                    position: relative;
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    margin-top: 0.28rem;
                    text-align: center;
                    // cursor: default;
                }
            }

            // .swiper-slide-active {
            //     transform: scale(1.3);
            // }

            // .swiper-slide-prev {
            //     transform: scale(1.1);
            // }

            // .swiper-slide-next {
            //     transform: scale(1.1);
            // }
            // .swiper-slide-active,
            // .swiper-slide-duplicate-active {
            //     transform: scale(1.3);
            //     z-index: 10;
            // }
        }
    }

    .img-matrix-box {
        height: 16.8rem;
        background: #F8FAFF;
        margin-top: 1.7rem;
        padding: 1.59rem 3.6rem 1.7rem 3.6rem;
        box-sizing: border-box;

        .img-matrix-fonts {
            width: 4.35rem;
            font-family: BoldFonts;
            font-weight: bold;
            font-size: 0.56rem;
            color: #536376;
            position: relative;
            left: 0;
            right: 0;
            margin: 0 auto;
            cursor: default;
        }

        .img-matrix-item-box {
            display: flex;
            justify-content: center;
            margin-top: 0.48rem;

            .img-matrix-itembox {
                width: 2.84rem;

                .img-martix-item {
                    width: 2.84rem;
                    // height: 3.98rem;
                    border-radius: 0.26rem;
                    padding: 0.1rem;
                    box-sizing: box-sizing;
                    border-radius: 0.26rem;

                    .img-martix-item-img {
                        width: 100%;
                        // height: 100%;
                        display: block;
                        border-radius: 0.26rem;
                    }
                    .zoomClass{
                        transform: scale(1.1)
                    }
                }
            }

            // .img-matrix-itembox-too{
            //     // display:flex;
            //     // flex-wrap: wrap;
            //     // justify-content: center;
            //     width: 2.84rem;
            //     .img-martix-item-too{
            //         width: 2.84rem;
            //         height: 3.98rem;
            //         // background: #E0A27D;
            //         border-radius: 0.26rem;
            //         padding:0.1rem;
            //         box-sizing:box-sizing;
            //         .img-martix-item-img-too{
            //             width:100%;
            //             height:100%;
            //             display:block;
            //         }
            //     }
            // }
        }
    }

    .card-box-class {
        padding: 1.6rem 3.6rem;
        box-sizing: border-box;

        .card-box-fonts {
            width: 9.27rem;
            font-family: BoldFonts;
            font-weight: bold;
            font-size: 0.56rem;
            color: #536376;
            position: relative;
            left: 0;
            right: 0;
            margin: 0 auto;
            cursor: default;
            text-align: center;
        }

        .card-item-box {
            margin-top: 0.6rem;
            display: flex;
            justify-content: center;

            .card-item {
                padding: 0.24rem 0.24rem 0.34rem 0.24rem;
                width: 5.88rem;
                // height: 7.8rem;
                background: #FFFFFF;
                box-shadow: 0px 0.3rem 0.5rem -0.12rem rgba(196, 205, 222, 0.7);
                border-radius: 0.26rem;
                box-sizing: border-box;

                .card-item-img {
                    width: 5.4rem;
                    height: 5.28rem;
                    display: block;
                }

                .card-item-fonts {
                    width: 5.4rem;
                    font-family: BoldFonts;
                    font-weight: 500;
                    font-size: 0.2rem;
                    color: #657384;
                    text-align: left;
                    margin-top: 0.3rem;
                }

                .card-item-button {
                    width: 2.5rem;
                    height: 0.6rem;
                    background: #F4F5F6;
                    border-radius: 0.3rem;
                    opacity: 1;
                    font-size: 0.2rem;
                    font-family: SemiboldFonts;
                    font-weight: 600;
                    color: #536376;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 0.5rem;

                    img {
                        width: 0.3rem;
                        height: 0.3rem;
                        margin-left: 0.1rem;
                    }
                }
            }
        }
    }

    // .technology-style {
    //     margin-top: 1.8rem;
    //     text-align: center;

    //     .technology-topFonts {
    //         font-size: 0.56rem;
    //         font-family: BoldFonts;
    //         font-weight: bold;
    //         color: #536376;
    //         line-height: 0.67rem;
    //         text-shadow: 0.08rem 0.12rem 0.24rem rgba(0, 0, 0, 0.05);
    //     }

    //     .technology-bottonFonts {
    //         font-size: 0.18rem;
    //         font-family: BoldFonts;
    //         color: #8B92A0;
    //         line-height: 0.27rem;
    //         margin-top: 0.1rem;
    //     }
    // }

    .three-box {
        display: flex;
        justify-content: center;
        margin-top: 0.6rem;

        &-item {
            width: 3.84rem;
            height: 2.79rem;
            // background: #F4F2F2;
            border-radius: 0.2rem;
            opacity: 1;
            border: #F4F2F2 solid 0.01rem;
            padding: 0.24rem;
            box-sizing: border-box;

            .item_img {
                width: 0.72rem;
                height: 0.72rem;
                display: block;
            }

            .item_title {
                margin-top: 0.23rem;
                font-family: SemiboldFonts;
                font-weight: 600;
                font-size: 0.24rem;
                color: #536376;
            }

            .item_content {
                font-family: Inter, Inter;
                font-weight: 500;
                font-size: 0.18rem;
                color: #8B92A0;
            }
        }

        .three-box-item+.three-box-item {
            margin-left: 0.18rem;
        }
    }

    // 轮播图1
    .swiper-top {
        height: 2.41rem;
        margin-top: 0.74rem;

        .swiperBox {
            width: 100%;

            .swiper-slide {
                box-sizing: border-box;
                width: 1.80rem !important;
                // margin-right: 0.24rem !important;
            }
        }

        .slideWrapper {
            width: 1.80rem;
            height: 2.41rem;
            // background: #F4F2F2;
            border: #F4F2F2 solid 0.01rem;
            border-radius: 0.2rem;

            .slideWrapper-img {
                width: 1.8rem;
                height: 1.8rem;
                display: block;
            }

            .slideWrapper-fonts {
                width: 1.7rem;
                font-family: Inter, Inter;
                font-weight: 500;
                font-size: 0.14rem;
                color: #536376;
                text-align: center;
                position: relative;
                left: 0;
                right: 0;
                margin: 0 auto;
                margin-top: 0.14rem;
            }
        }
    }


    // 轮播图2
    .swiper-bottom {
        height: 1.8rem;
        margin-top: 0.24rem;

        .swiperBox-bottom {
            width: 100%;

            .swiper-slide {
                box-sizing: border-box;
                width: 3.4rem;
                // margin-right: 0.24rem !important;

                .slideWrapper-bottom {
                    width: 3.4rem !important;
                    height: 1.8rem;
                    background: #F4F2F2;
                    border-radius: 0.2rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;

                    .bottom_left {
                        width: 1.4rem;
                        height: 1.4rem;
                        display: block;
                    }

                    .bottom_right {
                        width: 1.4rem;
                        height: 1.4rem;
                        display: block;
                    }
                }
            }
        }


    }

    //底部
    .footer {
        box-sizing: border-box;
        // height: 511px;
        background: #EBF2FF;
        border-radius: 0rem;
        opacity: 1;
        padding: 0.6rem 1.2rem 0.6rem 1.2rem;

        .footer-title {
            font-size: 0.24rem;
            font-family: BoldFonts;
            font-weight: bold;
            color: #536376;
            text-shadow: 0.08rem 0.12rem 0.24rem rgba(0, 0, 0, 0.05);
            text-align: center;
            cursor: default;
        }

        .footer-input-box {
            display: flex;
            justify-content: center;
            margin-top: 0.3rem;

            .footer-input {
                width: 4.45rem;
                position: relative;
                // border:none;
                display: flex;

                .input {
                    width: 4.45rem;
                    height: 0.5rem;
                    background: #FFFFFF;
                    border-radius: 0.3rem;
                    opacity: 1;
                    border-color: #fff;
                    outline-style: none;
                    font-size: 0.16rem;
                    font-family: RegularFonts;
                    font-weight: 400;
                    color: #000000;
                    caret-shape: bar;
                    caret-color: #000000;
                    padding: 0.1rem;
                    display: block;
                    border: none;
                }

                input::-webkit-input-placeholder {
                    /* Chrome/Safari/Opera */
                    font-family: RegularFonts;
                }

                .input:focus {
                    border-color: #FFFFFF;
                }

                button {
                    width: 1.4rem;
                    height: 0.48rem;
                    position: absolute;
                    bottom: 0;
                    top: 0;
                    margin: auto 0;
                    right: 0;
                    background: #4B48FF;
                    border-radius: 0.37rem;
                    opacity: 1;
                    border-color: #fff;
                    font-size: 0.16rem;
                    font-family: SemiboldFonts;
                    font-weight: 600;
                    color: #FFFFFF;
                    display: block;
                    border: none;
                    cursor: pointer;
                }
            }
        }

        .middle-box {
            margin-top: 0.51rem;

            .middle-style {
                display: flex;
                justify-content: left;
                align-items: center;
                margin-left: 2.7rem;

                .left-middle-style {
                    width: 1.6rem;
                    height: 0.5rem;
                }
            }

            .middle-line {
                width: 12rem;
                margin-top: 0.4rem;
                margin-left: 2.86rem;
                border-bottom: 0.01rem solid #536376;
            }

            .footer-buttom {
                margin-top: 0.2rem;
                margin-left: 2.86rem;
                height: 0.52rem;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .buttom-left {
                    font-size: 0.16rem;
                    font-family: SemiboldFonts;
                    font-weight: normal;
                    color: #536376;
                }

                // .buttom-right {
                //     display: flex;
                //     align-items: center;

                //     // &-item {
                //     //     width: 0.52rem;
                //     //     height: 0.52rem;
                //     //     border: 0.01rem solid #FFFFFF;
                //     //     border-radius: 0.3rem;
                //     //     text-align: center;
                //     //     line-height: 0.52rem;
                //     .buttom-right-item {
                //         width: 0.52rem;
                //         height: 0.52rem;
                //     }

                //     // }

                //     .buttom-right-item+.buttom-right-item {
                //         margin-left: 0.31rem;
                //     }

                // }
            }
        }

    }

}
</style>
